import React, { useState } from "react";
import Header from "../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import GeoSearch from "../../../components/PropertyComponent/GeoSearch";
import { postApi } from "../../AppApis";
import { DatePicker } from "antd";
import ProgressBar from "../../../components/ProgressBar";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils";
import dayjs from "dayjs";

const HomeInspectionScheduler = () => {
    const [inputError, setInputError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const location = useLocation();
    const propertyInfo = location?.state?.propertyInfo;
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        inspectionDate: "",
        timeSlot: "",
        estimatedSize: "",
        yearBuilt: "",
        address: propertyInfo?.address,
        city: propertyInfo?.city,
        state: propertyInfo?.state,
        zipCode: propertyInfo?.zipCode,
        specialInstructions: "",
        additionalServices: [],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleServiceToggle = (service) => {
        setFormData((prevData) => {
            const selectedServices = prevData.additionalServices.includes(service)
                ? prevData.additionalServices.filter((s) => s !== service)
                : [...prevData.additionalServices, service];
            return { ...prevData, additionalServices: selectedServices };
        });
    };
    const getAddressComponent = (addressComponents, type) => {
        const component = addressComponents.find((c) => c.types.includes(type));
        return component ? component.long_name : "";
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        // Prevent multiple submissions
        if (isSubmitting) {
            return;
        }

        try {
            if (!formData.inspectionDate) {
                showErrorToast("Please fill out all fields before submit");
                return;
            }

            setIsSubmitting(true);

            const response = await postApi(`/property-services/request_service`, {
                service_name: "HomeInspection",
                data: { ...formData, project_type: "airebrokers" },
            });
            if (response.response) {
                navigate("/services/home-inspection-confirmation");
            } else if (response.error) {
                toast.error(response.error.detail || "Failed to submit form. Please try again.", { toastId: "error" });
                setIsSubmitting(false);
            } else {
                toast.error("Failed to submit form. Please try again.", { toastId: "error" });
                setIsSubmitting(false);
            }
        } catch (error) {
            console.log("Error submitting form:", error);
            setIsSubmitting(false);
        }
    };

    const handleSqftChange = (e) => {
        const value = Number(e.target.value);
        const { name } = e.target;
        if (value >= 0 && value <= 50000) {
            setFormData({ ...formData, [name]: value });
            setInputError((pre) => ({
                ...pre,
                [name]: false,
            }));
        } else {
            setInputError((pre) => ({
                ...pre,
                [name]: true,
            }));
            // optional: toast or ignore
        }
    };

    const disablePastDates = (current) => {
        return current && current < dayjs().startOf("day");
    };
    return (
        <div className="tw-bg-background_color tw-min-h-screen tw-pt-[70px]">
            <Header title={"Home Inspection"} />
            <div className=" tw-p-[12px]">
                <ProgressBar currentStep={3} totalSteps={3} />

                <form onSubmit={onSubmit} className="tw-w-[80%]  max-sm:tw-w-full tw-flex tw-flex-col 2xl:tw-gap-[50px] tw-mx-auto ">
                    <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-4">
                        <h2 className="tw-text-[20px] tw-text-black tw-font-semibold">Schedule Your Inspection</h2>
                        <div className=" tw-flex tw-gap-5">
                            <div className="2xl:tw-gap-[15px] tw-w-full tw-flex tw-flex-col">
                                <label className="tw-text-gray-700 tw-text-[14px] 2xl:tw-text-[20px]">Inspection Date</label>
                                <DatePicker
                                    onChange={(date, dateString) => setFormData({ ...formData, inspectionDate: dateString })}
                                    required
                                    disabledDate={disablePastDates}
                                    className={`tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounde    d-md 2xl:placeholder:text-[24px]`}
                                    placeholder="DD/MM/YYYY"
                                />
                                {/* <input
                                    type="date" 
                                    required
                                    name="inspectionDate"
                                    value={formData.inspectionDate}
                                    onChange={handleChange}
                                    className="tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounded-md 2xl:placeholder:text-[24px]"
                                /> */}
                            </div>
                            <div className="2xl:tw-gap-[15px] tw-w-full tw-flex tw-flex-col">
                                <label className="tw-text-gray-700 tw-text-[14px] 2xl:tw-text-[20px]">Time Slot</label>
                                <input
                                    type="time"
                                    name="timeSlot"
                                    required
                                    placeholder="e.g., 9:00 AM - 11:00 AM"
                                    value={formData.timeSlot}
                                    onChange={handleChange}
                                    className="tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounded-md"
                                />
                            </div>
                        </div>

                        <h2 className="tw-text-[20px] tw-text-black tw-font-semibold">Home Details</h2>
                        <div className=" tw-flex tw-gap-5">
                            <div className="2xl:tw-gap-[15px] tw-w-full tw-flex tw-flex-col">
                                <label className="tw-text-gray-700 tw-text-[14px] 2xl:tw-text-[20px]">Estimated Size (unit: sqft)</label>
                                <input
                                    type="number"
                                    required
                                    name="estimatedSize"
                                    placeholder="e.g., 1500 sq ft"
                                    min={0}
                                    value={formData.estimatedSize}
                                    onChange={handleSqftChange}
                                    className="tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounded-md"
                                />
                                {inputError.estimatedSize && <p className="tw-text-red-500">Estimated size must be between 0 and 50,000.</p>}
                            </div>
                            <div className="2xl:tw-gap-[15px] tw-w-full tw-flex tw-flex-col">
                                <label className="tw-text-gray-700 tw-text-[14px] 2xl:tw-text-[20px]">Year Built</label>
                                <select
                                    name="yearBuilt"
                                    required
                                    value={formData.yearBuilt}
                                    onChange={handleChange}
                                    className="tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounded-md"
                                >
                                    <option value="">Select Year</option>
                                    {Array.from({ length: new Date().getFullYear() - 1950 + 1 }, (_, i) => 1950 + i)
                                        .reverse()
                                        .map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="tw-mt-4 tw-flex tw-flex-col 2xl:tw-gap-[15px]">
                        <label className="tw-text-gray-700 tw-text-[14px] 2xl:tw-text-[20px]">Special Instructions (optional)</label>
                        <textarea
                            name="specialInstructions"
                            placeholder="Any specific concerns or recent renovations?"
                            value={formData.specialInstructions}
                            onChange={handleChange}
                            rows={5}
                            className="tw-w-full tw-mt-1 tw-p-2 tw-border tw-rounded-md"
                        ></textarea>
                    </div>

                    <div className="tw-w-full tw-flex tw-justify-center">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`tw-w-fit tw-mt-4 2xl:tw-font-semibold 2xl:tw-text-[24px] tw-text-white tw-py-3 tw-px-10 tw-rounded-md tw-font-semibold tw-flex tw-items-center tw-gap-2 ${
                                isSubmitting
                                    ? "tw-bg-gray-400 tw-cursor-not-allowed"
                                    : "tw-bg-primary hover:tw-bg-primary_hover"
                            }`}
                        >
                            {isSubmitting && (
                                <svg
                                    className="tw-animate-spin tw-h-5 tw-w-5 tw-text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="tw-opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="tw-opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                            )}
                            {isSubmitting ? "Submitting..." : "Confirm Booking"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default HomeInspectionScheduler;
